#integrity-monitor-real-time-content {
  width: 70%;

  #integrity-monitor-real-time-info-text {
    color: var(--body-text-arrows-400);
  }

  gzTitle {
    padding: calc(var(--spacer) * 2.12) 0 calc(var(--spacer) * 2.12) 0;
    color: var(--black-layout-700-primary);
    opacity: 0.5;
  }

  #integrity-monitor-real-time-mode {
    display: none;
  }

  #integrity-monitor-real-time-rule-sets-section-labeled-content {
    margin-top: calc(var(--spacer) * 2);
  }

  #integrity-monitor-real-time-info-text-2 {
    margin-top: calc(var(--spacer));
  }

  gz-policy-panel-integrity-monitor-rule-sets {
    margin-top: calc(var(--spacer) * 2);
  }
}

integrity-monitor-real-time-rule-sets-section {
  margin-left: calc(var(--spacer) * 2);
}
